import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { of } from 'rxjs'

@Component({
  selector: 'gb-button-loader',
  templateUrl: './gb-button-loader.component.html',
  styleUrl: './gb-button-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbButtonLoaderComponent {
  @Input() loaded$ = of(false)
  @Input() usePrimaryColor = false
}
